<template>
  <div
    class="gto-dashboard gwizdash medium-scroll-track"
    style="min-height: 0"
  >
    <!-- <AnimSnowflakes
      v-if="lottieAnimActive && !lottieAnimHidden"
      style="z-index: 1"
    /> -->

    <div
      class="gwizdash_content_wrapper"
      style="z-index: 4"
    >
      <div class="gwizdash_content">
        <!-- <AnimLotties
          v-if="lottieAnimActive && !lottieAnimHidden"
          style="position: fixed; z-index: 8; height: 100vh; width: 100vw; top: 0; left: 0"
        /> -->

        <DashboardBannerRls v-if="$store.getters.user_has_flag('GTO_REP_BANNER') && !$i18n.g1" />
        <DashboardBanner v-if="$store.getters.user_has_flag('BANNER_EVENTS') && !$i18n.g1" />

        <PlaymentSlotWrapper v-if="gameformatTrial && nadaPurchased">
          <template #default="{ anyCheapPlan }">
            <div
              v-if="anyCheapPlan"
              class="f-center text-center pa-2 weight_500 b-radius_4"
              style="
                background-color: rgba(0, 0, 0, 0.3);
                color: var(--clr-primary);
                border: 1px solid rgba(7, 110, 91, 1);
                padding: 0.5rem 1rem;
              "
            >
              <div
                v-html="
                  !anyCheapPlan.discount
                    ? $t('messages.enjoy_free_version', { trial_hours: 24 })
                    : anyCheapPlan.discount && anyCheapPlan.price_type === 'DISCOUNT'
                      ? $t('messages.enjoy_free_version_discount', {
                          trial_hours: 24,
                          discount: anyCheapPlan.discount,
                        })
                      : $t('messages.enjoy_free_version_affiliate', {
                          trial_hours: 24,
                          affiliate_name: affiliateName,
                          discount: anyCheapPlan.discount,
                        })
                "
              ></div>
              <div
                v-if="anyCheapPlan.discount"
                class="ml-4 gw_btn gw_btn_text"
                style="--clr-back: rgba(7, 110, 91, 0.125); color: var(--clr-white-0)"
                @click="
                  $router.push({
                    name: 'SubscriptionPaymentSelection',
                  })
                "
              >
                {{ $t('btn.upgrade_now') }}
              </div>
            </div>
          </template>
        </PlaymentSlotWrapper>

        <WeChatSnackbar v-if="$i18n.locale === 'zh'" />
        <FutureCoaching class="anim-fade-in" />
        <DashboardLinks class="anim-fade-in">
          <!-- <template #title>
            <div
              v-if="lottieAnimActive"
              class="gw_btn clr-grey ml-auto weight_500 text-medium"
              @click.stop="toggleLottieAnim"
            >
              {{ !lottieAnimHidden ? 'Disable' : 'Enable' }} Dragon animations
            </div>
          </template> -->
        </DashboardLinks>
        <DashboardStats
          class="anim-fade-in"
          style="--width-right: var(--width-right-column)"
        />
        <DDose
          v-if="!$i18n.g1 && mobile"
          class="anim-fade-in"
        />
        <GlossaryWidget
          v-if="!$i18n.g1 && mobile"
          class="anim-fade-in"
        />
        <DashboardCoachings
          v-if="!$i18n.g1 && mobile"
          class="anim-fade-in"
        />

        <div
          v-if="!$i18n.g1"
          class="gwizdash_content_block anim-fade-in"
          style="--gap: 1.5rem"
        >
          <DashboardArticles
            ref="articles"
            class="flex-1"
          />
          <div class="gwizdash_right">
            <DDose v-if="!mobile" />
            <GlossaryWidget v-if="!mobile" />
            <DashboardCoachings v-if="!mobile" />
            <DashboardSubLinks />
            <DashboardSocials />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlossaryWidget from '@/components/Dashboard/GlossaryWidget'
import DDose from '@/components/Dashboard/DDose'
import FutureCoaching from '@/components/Messages/FutureCoaching'
import WeChatSnackbar from '@/components/Messages/WeChatSnackbar'
import DashboardBanner from '@/components/Messages/DashboardBanner'
import DashboardBannerRls from '@/components/Messages/DashboardBannerRls'
// import AnimSnowflakes from '@/components/animations/AnimSnowflakes'
// import AnimLotties from '@/components/animations/AnimLotties'
import tier_mix from '@/mixins/tier_mix'
// import links_mix from '@/mixins/links_mix'
import DashboardLinks from '@/components/Dashboard/DashboardLinks'
import DashboardStats from '@/components/Dashboard/DashboardStats'
import DashboardArticles from '@/components/Dashboard/DashboardArticles'
import DashboardSubLinks from '@/components/Dashboard/DashboardSubLinks'
import DashboardSocials from '@/components/Dashboard/DashboardSocials'
import DashboardCoachings from '@/components/Dashboard/DashboardCoachings'
import PlaymentSlotWrapper from '@/components/Payments/PlaymentSlotWrapper'

import { isBefore, isAfter } from 'date-fns'

export default {
  name: 'Dashboard',
  // mixins: [tier_mix, links_mix],
  components: {
    DashboardLinks,
    DashboardStats,
    DashboardArticles,
    DashboardSocials,
    DashboardSubLinks,
    DashboardCoachings,
    PlaymentSlotWrapper,
    GlossaryWidget,
    DDose,
    FutureCoaching,
    WeChatSnackbar,
    DashboardBanner,
    DashboardBannerRls,

    // EarlyBirdBanner,
    // AnimSnowflakes,
    // AnimLotties,
  },
  mixins: [tier_mix],
  data() {
    this.namespace = '' // tier_mix needs namespace
    return {
      // lottieAnimHidden: localStorage.getItem('dragon_yr_chinese_2024') === 'true',
    }
  },
  methods: {
    // toggleLottieAnim() {
    //   this.lottieAnimHidden = !this.lottieAnimHidden
    //   localStorage.setItem('dragon_yr_chinese_2024', this.lottieAnimHidden)
    // },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
    // lottieAnimActive() {
    //   // return true
    //   return (
    //     this.$i18n.locale === 'zh' &&
    //     (import.meta.env.VITE_BRANCH !== 'master' ||
    //       (isAfter(new Date(), new Date('2024-02-09T16:00:00')) &&
    //         isBefore(new Date(), new Date('2024-02-15T23:59:59'))))
    //   )
    // },
    bannerActive() {
      // return true
      return isBefore(new Date(), new Date('2024-08-25T23:59:59'))
    },
    bannerRlsActive() {
      // return true
      return isBefore(new Date(), new Date('2024-08-25T23:59:59'))
    },
  },
}
</script>
<style lang="scss" scoped>
.gwizdash {
  display: flex;
  min-height: var(--vh-3);
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  flex-direction: column;
  --width-right-column: 20rem;
  &_content_wrapper {
    min-height: var(--vh-3);
    flex-shrink: 0;
    position: relative;
  }
  &_content {
    margin: 0 auto;
    padding: 2.5rem 0.5rem;
    width: clamp(12rem, 75.5rem, 100vw);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    &_block {
      --gap: 0rem;
      gap: var(--gap);
      width: 100%;
      display: flex;
    }
  }
  &_right {
    display: flex;
    flex-direction: column;
    --gap: 1rem;
    gap: var(--gap);
    max-width: var(--width-right-column);
    min-width: var(--width-right-column);
  }
}

@media (max-width: 1023px) {
  .gwizdash {
    --width-right-column: 100%;
    &_content {
      &_block {
        flex-direction: column;
      }
    }
    &_right {
      max-width: 100%;
    }
  }
}
</style>
